export default "__VITE_ASSET__DSDdYEaG__"